import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

import type { DefectComment } from '../../actions/defectComments'
import { getColor, theme } from '../../Theme'
import { formatDateTime } from '../defects/DefectsRow'

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  flex-direction: column;
  gap: 8px;
  display: flex;
`

const Item = styled.li<{ active: boolean }>`
  border-radius: ${theme.borderRadius.button};
  &:last-child {
    background: ${(p) =>
      p.active
        ? getColor(p.theme, ['subtleGreen', 'white'], ['darkGreen', 'grayDark'])
        : 'transparent'};
  }
`

export const DefectTextBold = styled.b`
  font-weight: bold;
`

export const DefectTextRow = styled.p`
  margin: 0;
  white-space: pre-wrap;
  text-wrap: wrap;
  font-size: ${theme.font.normal};
`

type Props = {
  comments: DefectComment[]
  successToastVisible: boolean
}

export const CommentList = ({ comments, successToastVisible }: Props) => {
  const { t } = useTranslation()

  if (comments.length === 0) {
    return null
  }

  return (
    <List>
      {comments.map((c, index) => (
        <Item key={index} active={successToastVisible}>
          <DefectTextRow>
            <DefectTextBold>{c.ownComment ? t('you') : t(`crewType.${c.crewType}`)}</DefectTextBold>
            <DefectTextBold> {formatDateTime(c.created)}: </DefectTextBold>
            {c.comment}
          </DefectTextRow>
        </Item>
      ))}
    </List>
  )
}
